export default "__VITE_ASSET__8rL97KhV__"